<template>
  <v-app>
    <app-navigation></app-navigation>
    <v-content transition="slide-x-transition">
      <router-view></router-view>
    </v-content>
    <!--<service-status></service-status>-->
  </v-app>
</template>

<script>
import AppNavigation from './components/AppNavigation'

export default {
  name: 'App',
  components: {
    AppNavigation
  },
  data () {
    return {
      //
    }
  }
}
</script>
